module.exports = __webpack_public_path__ + "static/power1-2@2x-2de0d4fb2eb7a8153d4e700638fe1b8d.png";